module.exports = __webpack_public_path__ + "assets/img/page3-design-side-nav-expanded-3-c0c0bbef.png";